import React, {useMemo} from "react";
import {ControlLabel} from "react-bootstrap";
import {filterNullableValues} from "../../../../helpers/filterNullableValues";

const WidgetEmbedCode = ({eventKey, widgetKey, widgetName, params = {}}) => {

    const query = useMemo(() => {
        let query = filterNullableValues(params);

        if (widgetKey) {
            query = {...query, widgetKey};
        }

        return JSON.stringify(query, null, 4);
    }, [params]);

    return (
        <>
            <ControlLabel>Код для встраивания</ControlLabel>
            <pre style={{ whiteSpace: "initial" }}>
                &lt;div id=&quot;widget-{widgetName}&quot;&gt;&lt;/div&gt;
                <br />
                <br />
                &lt;script src="{location.origin}
                /widget/static/js/embed.js" &gt;&lt;/script&gt;
                <br />
                <br />
                &lt;script&gt;
                <br />
                {`
                    createWidgetFrame(
                        document.querySelector("#widget-${widgetName}"),
                        "${
                            location.origin
                        }/widget/${eventKey}/${widgetName}",
                        ${query}
                    );
                `}
                <br />
                &lt;/script&gt;
            </pre>
        </>
    );
};

export default WidgetEmbedCode;
